/*
  Rostund – produktsidan: färgval (variant), antal ("2 st för 299 kr", "Lockband + sovmössa"),
  galleri, fast köpknapp på mobil och beräknad leverans. Kräver theme.js.
*/
(() => {
  const T = window.theme;
  const root = document.querySelector("[data-product-page]");
  if (!T || !root) return;
  const { $, $$, fill, formatMoney: fm, tierPct, reduceMotion } = T;

  const form = $("[data-product-form]", root);
  const idInput = $("[data-variant-id]", root);
  const qtyInput = $("[data-quantity]", root);
  const priceRow = $("#buy-price", root);
  const atc = $("#atc", root);
  const stickyBtn = document.getElementById("atc-sticky");
  const stickyPrice = document.getElementById("sticky-price");
  const sticky = document.getElementById("sticky-buy");
  const title = root.dataset.title || "";

  let qty = 1;
  let variant = {
    id: Number(idInput?.value),
    price: Number(root.dataset.price) || 0,
    compare: Number(root.dataset.compare) || 0,
    available: root.dataset.available !== "false",
  };

  function priceHtml(total, was) {
    let html = `<span class="price">${fm(total)}</span>`;
    if (was > total) {
      html += `<s class="price-was">${fm(was)}</s><span class="save-tag">${fill(T.strings.save, { amount: fm(was - total) })}</span>`;
    }
    return html;
  }

  // Valt alternativ i "Välj antal". Knappar med data-total har fast pris (t.ex. "2 st för 299 kr"
  // eller "Lockband + sovmössa"), annars räknas procent-trappan.
  let tier = $("[data-qty][aria-checked=\"true\"]", root);
  // Förvalt alternativ kan vara 2 st (temainställning), så antalet följer det från början
  qty = Number(tier?.dataset.qty) || 1;
  if (qtyInput) qtyInput.value = qty;
  const addonPicks = $$("[data-addon-pick]", root);
  const tierAddons = (btn) => (btn?.dataset.addons || "").split(",").filter((x) => x !== "");

  function tierTotal(btn, n) {
    if (btn?.dataset.total) return Number(btn.dataset.total) || 0;
    return Math.round((variant.price * n * (100 - tierPct(n))) / 100);
  }

  function updatePrice() {
    const total = tierTotal(tier, qty);
    const full = tier?.dataset.full ? Number(tier.dataset.full) : (variant.compare > variant.price ? variant.compare : variant.price) * qty;
    if (priceRow) priceRow.innerHTML = priceHtml(total, full);
    if (atc) {
      atc.textContent = variant.available ? fill(T.strings.addToCartPrice, { price: fm(total) }) : T.strings.soldOut;
      atc.disabled = !variant.available;
    }
    if (stickyBtn) stickyBtn.disabled = !variant.available;
    if (stickyPrice) stickyPrice.textContent = fm(total);

    $$("[data-qty]", root).forEach((btn) => {
      if (btn.dataset.total) return;
      const n = +btn.dataset.qty;
      const t = tierTotal(btn, n);
      const el = $("[data-qty-price]", btn);
      if (el) el.innerHTML = fm(t) + (n > 1 ? `<small>${fill(T.strings.each, { amount: fm(t / n) })}</small>` : "");
    });
  }

  function selectVariant(el) {
    variant = {
      id: Number(el.dataset.variant ?? el.value),
      price: Number(el.dataset.price) || 0,
      compare: Number(el.dataset.compare) || 0,
      available: el.dataset.available !== "false",
    };
    if (idInput) idInput.value = variant.id;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    } catch {
      /* ignorera */
    }
    updatePrice();
  }

  root.addEventListener("click", (e) => {
    const color = e.target.closest("[data-color]");
    if (color) {
      $$("[data-color]", root).forEach((b) => b.setAttribute("aria-checked", String(b === color)));
      const name = $("#color-name", root);
      if (name) name.textContent = color.dataset.color;
      selectVariant(color);
      setThumbs("main", color.dataset.img);
    }
    const q = e.target.closest("[data-qty]");
    if (q) {
      tier = q;
      qty = +q.dataset.qty || 1;
      if (qtyInput) qtyInput.value = qty;
      $$("[data-qty]", root).forEach((b) => b.setAttribute("aria-checked", String(b === q)));
      const show = tierAddons(q);
      addonPicks.forEach((el) => (el.hidden = !show.includes(el.dataset.addonPick)));
      updatePrice();
    }
    const thumb = e.target.closest("[data-thumb]");
    const main = $("#main-img", root);
    if (thumb && main) {
      main.scrollTo({ left: main.clientWidth * +thumb.dataset.thumb, behavior: reduceMotion ? "auto" : "smooth" });
    }
  });

  $("[data-variant-select]", root)?.addEventListener("change", (e) => {
    const opt = e.target.selectedOptions[0];
    if (opt) selectVariant(opt);
  });

  // Miniatyrerna i "Välj antal" följer vald färg på bandet och på tilläggen
  function setThumbs(key, src) {
    if (!src) return;
    $$(`[data-tier-img="${key}"]`, root).forEach((img) => (img.src = src));
  }
  addonPicks.forEach((pick) => {
    $("select[data-addon-variant]", pick)?.addEventListener("change", (e) => {
      setThumbs(pick.dataset.addonPick, e.target.selectedOptions[0]?.dataset.img);
    });
  });

  const add = (trigger) => {
    const items = [{ id: variant.id, quantity: qty }];
    tierAddons(tier).forEach((i) => {
      const pick = addonPicks.find((el) => el.dataset.addonPick === i);
      const id = Number($("[data-addon-variant]", pick)?.value);
      if (id) items.push({ id, quantity: 1 });
    });
    return T.addToCart(items, title, trigger);
  };
  form?.addEventListener("submit", (e) => {
    e.preventDefault();
    add(atc);
  });
  stickyBtn?.addEventListener("click", () => add(stickyBtn));

  // Markera rätt miniatyr när man sveper i galleriet
  const main = $("#main-img", root);
  main?.addEventListener(
    "scroll",
    () => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      $$("[data-thumb]", root).forEach((b) => b.setAttribute("aria-current", String(+b.dataset.thumb === i)));
    },
    { passive: true }
  );

  // Fast köpknapp på mobil när den vanliga knappen scrollat ur bild
  if (sticky && atc && "IntersectionObserver" in window) {
    new IntersectionObserver(([en]) => sticky.classList.toggle("is-on", !en.isIntersecting), {
      rootMargin: "0px 0px 100000px 0px",
    }).observe(atc);
  }

  // Beräknad leverans: packning i vardagar, frakt i kalenderdagar
  const delivery = $("[data-delivery]", root);
  const range = $("[data-delivery-range]", root);
  if (delivery && range) {
    const [pMin, pMax] = (delivery.dataset.processing || "1,3").split(",").map(Number);
    const [dMin, dMax] = (delivery.dataset.days || "8,18").split(",").map(Number);
    const addBusinessDays = (date, n) => {
      const d = new Date(date);
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) n--;
      }
      return d;
    };
    const addDays = (date, n) => {
      const d = new Date(date);
      d.setDate(d.getDate() + n);
      return d;
    };
    try {
      const fmt = new Intl.DateTimeFormat(document.documentElement.lang || "sv-SE", { weekday: "short", day: "numeric", month: "short" });
      const f = (d) => fmt.format(d).replace(/\./g, "");
      const from = addDays(addBusinessDays(new Date(), pMin), dMin);
      const to = addDays(addBusinessDays(new Date(), pMax), dMax);
      range.textContent = fill(T.strings.deliveryRange, { from: f(from), to: f(to) });
    } catch {
      /* behåll reservtexten från Liquid */
    }
  }

  updatePrice();
})();
